import Vue from 'vue'
import AlertComponent from './alert'
function merge(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }
  return target;
};
let instance;
let AlertConstructor = Vue.extend(AlertComponent);

let initInstance = ()=>{
  instance = new AlertConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
}

let Alert = (options={}) => {
  //初始化
  initInstance();
  // 将单个 confirm instance 的配置合并到默认值（instance.$data，就是main.vue里面的data）中
  merge(instance.$props, options);
  /*fix 弹窗出来之后依旧键盘没有回收*/
  let inputs = Array.prototype.slice.call(document.querySelectorAll('input'));
  inputs.forEach((input) => {
    input.blur();
  });
  //返回Promise
  return new Promise((resolve, reject)=>{
    instance.show = true;
    let success = instance.success;
    let cancel = instance.cancel;
    instance.success = () => {
      //先执行instance.success（main.vue里面的success函数）
      success();
      //再执行自定义函数
      resolve('ok');
    }
  });

}
export default Alert
/*export default {
  install(Vue){
    Vue.component(Alert.name, Alert)
    //添加全局API
    Vue.prototype.$alert = Alert
  }
}*/



// WEBPACK FOOTER //
// ./src/plugins/alert/index.js